export const routeConfig = (): { [key: string]: any } => {
    return {
    "absxasindata": {
        "type": "link",
        "label": "ABSX ASIN Data",
        "href": "#/absxasindata",
        "route": "TabularQueryFormApp"
    },
    "asindatastore": {
        "type": "link",
        "label": "Asin Data Service V2 (Beta)",
        "href": "#/asindataservice",
        "route": "TabularQueryFormApp"
    },
    "tas": {
        "type": "link",
        "label": "TAS",
        "href": "#/tas",
        "route": "TabularQueryFormApp"
    },
    "tdf": {
        "type": "link",
        "label": "TDF",
        "href": "#/tdf",
        "route": "TwoContainerApp"
    }
}
}